export default "/_next/static/chunks/fonts/Channel4Horseferry-Medium-3ebd866588b7a180300bc70136e493d2.woff";